import { render, staticRenderFns } from "./DataChart.vue?vue&type=template&id=ee023c68&scoped=true&"
import script from "./DataChart.vue?vue&type=script&lang=ts&"
export * from "./DataChart.vue?vue&type=script&lang=ts&"
import style0 from "./DataChart.vue?vue&type=style&index=0&id=ee023c68&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee023c68",
  null
  
)

export default component.exports